import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import { HyphenIcon } from "@transfr-inc/dashboard-components";

import { MasteryStatus, OohStatus } from "@models";
import { ContentType } from "@transfr-inc/dashboard-components/curriculum";

import { getOohStatusConfig, getStatusConfigOverview } from "./cell.utils";

import "./status-cell.scss";

export function ActivityStatusCell({ status, row }) {
  if (status === MasteryStatus.Exempt) {
    return (
      <div className={clsx("activity-mastery-cell", "exempt")}>
        <FontAwesomeIcon icon={"fa-regular fa-ban"} />
        Exempt
      </div>
    );
  }

  let config;
  if (
    row?.contentType === ContentType.OutOfHeadset.id ||
    row?.contentType === ContentType.Assessment.id
  ) {
    config = getOohStatusConfig(status, row?.masteryScore);
  } else if (row?.contentType === ContentType.CurriculumResources.id) {
    const normalizedStatus =
      status === OohStatus.COMPLETED ? MasteryStatus.Complete : status;
    config = getStatusConfigOverview(normalizedStatus, false);
  } else {
    config = getStatusConfigOverview(status, row?.displayScore);
  }

  const { classname, icon, text } = config;
  const displayText = row?.displayStatus ?? text;

  // Show status if it exists, even when locked
  const hasStatus = status !== MasteryStatus.NotStarted && status;

  if (hasStatus) {
    return (
      <div className={clsx("activity-mastery-cell", classname)}>
        <FontAwesomeIcon icon={icon} />
        {displayText}
      </div>
    );
  }

  // If locked and no status, show lock icon
  if (row?.locked) {
    return (
      <div className="locked-cell">
        <FontAwesomeIcon icon="fa-regular fa-lock" />
      </div>
    );
  }

  // Otherwise show hyphen
  return <HyphenIcon />;
}
